import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { Tabs as BaseTabs, Tab as BaseTab } from '@material-ui/core'

export const Labels = styled(forwardRef(({ alignment, ...props }, ref) => <BaseTabs {...props} ref={ref} />))`
  &.MuiTabs-root {
    font-family: ${props => props.theme.typography.fontFamily};
    position: relative;
  }

  &.MuiTabs-root .MuiTabScrollButton-root {
    justify-content: flex-start;
    opacity: 1;
    width: 30px;

    &:last-of-type {
      justify-content: flex-end;
    }

    & .MuiTouchRipple-root {
      display: none;
    }
  }

  &.MuiTabs-root .MuiTabScrollButton-root.Mui-disabled {
    opacity: 0;
  }

  &.MuiTabs-root .MuiTabScrollButton-root .MuiSvgIcon-root {
    fill: ${props => props.theme.palette.gray[50]};

    &:hover {
      fill: ${props => props.theme.palette.gray[75]};
    }
  }

  &.MuiTabs-root .MuiTabs-flexContainer {
    justify-content: ${props => {
      if (props.alignment !== 'left') {
        return props.alignment === 'center' ? 'center' : 'flex-end'
      }

      return 'flex-start'
    }};
  }

  &.MuiTabs-root .MuiTabs-indicator {
    background-color: ${props => props.theme.palette.blue[50]};
    height: 3px;
    z-index: 1;
  }

  &.MuiTabs-root .MuiTabs-borderBottom {
    background-color: ${props => props.theme.palette.gray[75]};
    border: 0;
    bottom: 0;
    box-sizing: border-box;
    height: 2px;
    left: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: 0;
  }
`

export const Label = styled(BaseTab)`
  &.MuiTab-root {
    color: ${props => props.theme.palette.gray[50]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    opacity: 1;
    padding: 10px 30px 20px;

    & .MuiTouchRipple-root {
      display: none;
    }
  }

  &.MuiTab-root.Mui-selected {
    color: ${props => props.theme.palette.blue[50]};
  }

  &.MuiTab-root.Mui-disabled {
    color: ${props => props.theme.palette.gray[75]};
    cursor: not-allowed;
    opacity: 1;
  }

  &.MuiTab-root.Mui-disabled ${Labels}.MuiTabs-root .MuiTabs-indicator {
    background-color: ${props => props.theme.palette.gray[75]};
  }
`

export const Panels = styled.div`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`
